import { useState, useEffect } from "react";

export default function useWindowDimensions() {
	const getSize = () => ({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const [windowSize, setWindowSize] = useState(getSize());

	useEffect(() => {
		console.log("window.innerWidth: ", window.innerWidth);

		function handleResize() {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return windowSize;
}
